import {
    RECURRING_OFFSET_TYPE,
} from 'config/CustomEnums';
import { CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';

export function validateRecurringPeriod({ isActive, isStart, recurringDate, errorList }) {
    const readableErrorField = `readableRecurring${isActive ? 'Active' : 'Visible'}Period`;
    const fieldNamePrefix = (isActive ? "active" : "visible") + (isStart ? "Start" : "End")
    const followFieldName = (isActive ? "active" : "visible") + 'PeriodFollowBirthMonth'
    const periodFollowBirthMonth = recurringDate[followFieldName]
    if (periodFollowBirthMonth) {
        return
    }
    const beforeOrAfterInMessage = isStart ? "before" : "after"
    const offsetType = recurringDate[`${fieldNamePrefix}DateOffsetType`]
    const offsetMonth = recurringDate[`${fieldNamePrefix}OffsetMonths`]
    const errorName = `recurringDate.${fieldNamePrefix}`
    const message = "Invalid input, please try again. And Only numbers greater than or equal to 0 can be entered"
    const monthRequiredType = [
        RECURRING_OFFSET_TYPE.OFFSET_BY_RELATIVE_MONTH,
        RECURRING_OFFSET_TYPE.OFFSET_DAY_IN_MONTH,
        RECURRING_OFFSET_TYPE.OFFSET_WEEKDAY
    ]
    const numberMonths = parseInt(offsetMonth, 10);
    if (monthRequiredType.includes(offsetType) && (isNaN(numberMonths) || numberMonths < 0)) {
        errorList.push({
            sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
            name: errorName,
            message: message,
        });
        errorList.push({
            name: readableErrorField,
            message: "error"
        });
    }
    switch (offsetType) {
        case RECURRING_OFFSET_TYPE.OFFSET_BY_RELATIVE_DAY:
            const offsetDays = recurringDate[`${fieldNamePrefix}OffsetDays`]
            const numberDays = parseInt(offsetDays, 10);
            if (isNaN(numberDays) || numberDays < 0) {
                errorList.push({
                    sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
                    name: errorName,
                    message: message,
                });
                errorList.push({
                    name: readableErrorField,
                    message: "error"
                });
            }
            break
        case RECURRING_OFFSET_TYPE.OFFSET_BY_RELATIVE_WEEK:
            const offsetWeeks = recurringDate[`${fieldNamePrefix}OffsetWeeks`]
            const numberWeeks = parseInt(offsetWeeks, 10);
            if (isNaN(numberWeeks) || numberWeeks < 0) {
                errorList.push({
                    sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
                    name: errorName,
                    message: message,
                });
                errorList.push({
                    name: readableErrorField,
                    message: "error"
                });
            }
            break
        case RECURRING_OFFSET_TYPE.OFFSET_DAY_IN_MONTH:
            const specificDayInMonth = recurringDate[`${fieldNamePrefix}SpecificDayInMonth`]
            if (!specificDayInMonth) {
                errorList.push({
                    sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
                    name: errorName,
                    message: message,
                });
                errorList.push({
                    name: readableErrorField,
                    message: "error"
                });
            }
            break
        default:
            break
    }
}